import React from "react";

import { marketAndroid, marketIos } from "../../pages/AppInstall";

import useSimplePopup from "../../hooks/useSimplePopup";
import useStore from "../../hooks/useStore";
import { useDeviceType } from "../../hooks/useDeviceType/Index";
import useFinishApplication from "../../hooks/useFinishApplication";

import HorizontalRule from "../Rule/Horizontal";
import CommonButton from "../Button";

import ForceUpdateImage from "../../assets/img/force-update.png";

type Props = {};

export default function ForceUpdate({}: Props) {
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [storeCall] = useStore({ open });
  const deviceType = useDeviceType();
  const [finishCall] = useFinishApplication({ open });

  return (
    <div className="w-screen min-h-screen h-[calc(100%-20px)] relative bg-white">
      <div className="w-full h-full left-0 pt-[94px] absolute flex-col justify-start items-center inline-flex gap-20">
        <div className="flex-col justify-start items-center gap-20 flex px-5 w-full">
          <div className="self-stretch h-[207px] pb-[30px] flex-col justify-start items-center gap-[30px] flex w-full">
            <div className="flex-col justify-start items-center gap-2.5 flex">
              <div className="text-center text-black text-2xl font-semibold leading-[33.60px]">
                새로운 버전이
                <br />
                업데이트 되었어요!
              </div>
              <div className="text-center text-neutral-500 text-sm font-normal leading-[18px]">
                지금 바로 업데이트하고 샌디를 즐겨보세요
              </div>
            </div>
            <HorizontalRule
              className="bg-brand-neutral-05 border-brand-neutral-05"
              margin="0"
            />
            <div className="text-center text-neutral-500 text-xs font-normal leading-tight">
              업데이트 하지 않으면 샌디를 이용할 수 없어요
            </div>
          </div>
        </div>
        <img
          className="w-full object-cover h-[100vw] object-top"
          src={ForceUpdateImage}
        />
      </div>

      <div className="bg-white fixed bottom-0 w-full flex">
        <CommonButton
          variant="secondary"
          className="w-[45%] rounded-none text-base px-4 py-3 h-bottom-button"
          onClick={async () => {
            finishCall();
          }}
        >
          다음에 할게요
        </CommonButton>
        <CommonButton
          className="w-[55%] rounded-none text-base px-4 py-3 h-bottom-button"
          onClick={() => {
            if (deviceType === "Android") {
              storeCall("", marketAndroid);
            } else if (deviceType === "iOS") {
              storeCall("", marketIos);
            } else {
              open("데스크탑에서는 앱 연동은 미지원 상태입니다.");
            }
          }}
        >
          업데이트
        </CommonButton>
      </div>
      {simplePopupComponent}
    </div>
  );
}
